/* BC Silver city constant parkings */


export const TP_1_PARKING = '3731777538000';
export const TP_2_PARKING = '3731777547000';
export const TP_3_PARKING = '3731777550000';
